<div class="container" fxLayout="column">

    <div class="std-name">
        Learning Standard <b>{{standard?.StandardName}}</b>
    </div>

    <div class="std-desc">
        <b>Learning Standard Description</b>
        <hr>
         {{standard?.StandardDescription}}
    </div>


    
    <div 
    class="lesson-table-container"
    *ngFor="let lesson of standard?.LessonProgress">
                
        <div class="lesson-name"><b>{{lesson.LessonName}}</b></div>

        <hr>

        <p *ngIf="!lesson?.Attempts || lesson.Attempts.length < 1"><b>There are no attempts for this lesson</b></p>

        <div *ngIf="lesson?.Attempts">
            <table class="table-border">
                <thead>
                    <th class="grade-attempt">Grade</th>
                    <th class="status">Status</th>
                    <th class="date-attempt">Complete Date</th>
                </thead>
                <tbody>
                    <tr
                    *ngFor="let aData of lesson?.Attempts
                    | orderBy: 'Sequence':'asc';
                    let i = index">
                        <td class="grade-attempt"
                        [class.red-grade]="checkForRedGrade(aData?.Grade)"
                        [class.green-grade]="checkForGreenGrade(aData?.Grade)">
                            {{ aData?.Grade ? aData?.Grade + "%" : "N/A" }}
                        </td>
                        <td class="status">{{ aData?.Status || "" }}</td>
                        <td class="date-attempt">{{ aData?.CompleteDate || "N/A" }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
                    
    </div>

    <div class="no-lessons"
    *ngIf="!standard.LessonProgress?.length">
        <b>There are no lessons associated with this standard.</b>
    </div>

    <div fxLayout="row" fxLayoutAlign="center">
        <div>
            <button class="button secondary-button m-15" (click)="onCancel()">Close</button>
        </div>
    </div>
</div>
